import React from 'react';
import { cx, focusRing, motion } from './classes';

const METER_DELAYS = ['', '[animation-delay:-300ms]', '[animation-delay:-550ms]'];

/** Three small amber bars moving while a clip is analyzed; they hold still under reduced motion */
export const AnalyzingMeter = ({ className }) => (
  <span aria-hidden="true" className={cx('h-3.5 inline-flex items-end gap-0.5', className)}>
    {METER_DELAYS.map((delay, i) => (
      <span key={i} className={cx('w-[3px] h-3.5 rounded-full bg-amber origin-bottom animate-level motion-reduce:animate-none', delay)} />
    ))}
  </span>
);

/**
 * One clip in the project sidebar: name and instrument tag, then its latest score and version, or
 * a small meter and "Analyzing" while a version is analyzed. Selection is shown by the raised
 * background alone, never a colored edge.
 */
export const ClipRow = ({ name, tag, score, version, analyzing = false, selected = false, onSelect }) => (
  <button
    type="button"
    aria-current={selected ? 'true' : undefined}
    onClick={onSelect}
    className={cx(
      'w-full min-h-[56px] px-space-3 py-space-2 flex items-center gap-space-3 text-left rounded-radius-md text-ink transition-colors hover:bg-raised',
      selected ? 'bg-raised' : 'bg-transparent',
      motion,
      focusRing
    )}
  >
    <span className="flex-1 min-w-0 flex flex-col gap-0.5 font-text">
      <span className="truncate text-small font-bold">{name}</span>
      {tag && <span className="truncate text-caption text-muted">{tag}</span>}
    </span>
    {analyzing ? (
      <span className="flex-none flex flex-col items-end gap-1">
        <AnalyzingMeter />
        <span className="font-text text-[12px] leading-snug text-muted">Analyzing</span>
      </span>
    ) : (
      <span className="flex-none flex flex-col items-end gap-0.5 font-mono">
        {score != null ? (
          <span className="text-data-sm">{score}/10</span>
        ) : (
          <>
            <span className="text-data-sm text-muted" aria-hidden="true">–</span>
            <span className="sr-only">Not scored</span>
          </>
        )}
        {version != null && <span className="text-[12px] leading-snug text-muted">V{version}</span>}
      </span>
    )}
  </button>
);
